export default __webpack_public_path__ + "/assets/qr_sl.png";